import { PASSWORD_MESSAGE } from '@shared/auth-rules';

export function authErrorMessage(code: string | undefined): string {
  switch (code) {
    case 'auth/invalid-credential':
    case 'auth/wrong-password':
    case 'auth/user-not-found':
    case 'auth/invalid-email':
      return 'Incorrect username or password.';
    case 'auth/user-disabled':
      return 'This account has been disabled. Contact an administrator.';
    case 'auth/too-many-requests':
      return 'Too many attempts. Wait a few minutes and try again.';
    case 'auth/network-request-failed':
      return 'Network error. Check your connection and try again.';
    case 'auth/popup-closed-by-user':
    case 'auth/cancelled-popup-request':
      return 'Google sign-in was cancelled.';
    case 'auth/requires-recent-login':
      return 'Please sign in again before changing your password.';
    case 'auth/weak-password':
      return PASSWORD_MESSAGE;
    default:
      return 'Sign-in failed. Try again.';
  }
}
